module.exports = __webpack_public_path__ + "11_mole.4696ae59.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/11_mole.png
// module id = 2ybo
// module chunks = 0